//#region IMPORT
import React, { useCallback, useEffect, useRef, useState } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { showLoading, closeLoading } from '../../../../Reducer/LoadingReducer';
import { setSearchText } from '../../../../Reducer/SearchReducer';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import { mapParamsBySchema } from '../../../../util';
/** Components */
import { SER_BASIC } from './index';
import dayjs from 'dayjs';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useDelete from '../../../../hooks/useDeleteN';
import { useSave } from '../../../../hooks/useSaveN';
import { useDelete1, useSearch2 } from './SER_BASIC_QUERY';
import { SER_BASIC_Schema } from './SER_BASIC_Schema';
import { SER_BASIC_01_Schema } from '../SER_BASIC_01/SER_BASIC_01_Schema';
import SER_BASIC_FormPopup from './SER_BASIC_FormPopup';
import { useOpenDraftForm, useSearchFormList } from './SER_BASIC_FORM_QUERY';
import {
  HasActiveFormRow,
  MapFormListRow,
  ParseFormDataResponse,
} from './SER_BASIC_FORM_Storage';
import { SER_BASIC_FORM_Schema } from './SER_BASIC_FORM_Schema';
import {
  BuildSeriousAccidentExcelFileName,
  DownloadSeriousAccidentExcelAll,
  MapDetailApiRowsToEvaluation,
  MergeTemplateWithDetailRows,
} from '../SER_BASIC_01/SER_BASIC_01_Excel';
import { useNavigate } from 'react-router-dom';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'SeriousAccidentAct';

const Title = [
  '1.경영자의 안전보건경영활동 (100점)',
  '2.위험성 평가 (100점)',
  '3.안전보건교육 (100점)',
  '4.근로자 참여 (100점)',
  '5.중대재해 대응조치 (100점)',
  '6.도급.용역.위탁 안전보건확보 (100점)',
  '7.평가 및 개선 (100점)',
  '8.안전문화 및 안전의식 (100점)',
  '9.가점 사항 (100점)',
];

function SER_BASICF() {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, custInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const gridRef1 = useRef(); //그리드
  const onGridReady = (params) => {
    gridRef1.current = params;
  };
  const [indList, setIndList] = useState([]); //공통코드 데이터

  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: false, requireCust: true });

  /* 그리드 기능 변수 */
  const [rowData1, setRowData1] = useState([]); // 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);

  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [formListRows, setFormListRows] = useState([]);
  const [formListLoading, setFormListLoading] = useState(false);

  const searchFormList = useSearchFormList();

  // 상태값 리셋
  const ResetLogic1 = useCallback(() => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  }, []);

  // QUERY: 삭제/조회 훅 연결
  const delete1 = useDelete1({
    userInfo,
    search: searchInfo,
    custCd: searchInfo?.custCd,
  });
  const search1 = useSearch2();
  const openDraftForm = useOpenDraftForm();

  // 삭제 Handler
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  //#endregion

  const executed = useRef(false);

  // 새로고침 시 Redux searchInfo 복원 전에는 custCd가 비어 있어 조회가 스킵됨 → custCd 준비 후 1회 자동 조회
  useEffect(() => {
    if (!searchInfo?.custCd) return;
    if (executed.current) return;
    executed.current = true;
    ResetLogic1();
    if (!validateSelection()) return;
    SearchLogic1();
  }, [searchInfo?.custCd]); // eslint-disable-line react-hooks/exhaustive-deps

  const SearchLogic1 = useCallback(async () => {
    ResetLogic1();

    if (!validateSelection()) return;

    try {
      await search1.runAsync(
        {
          search: searchInfo,
          custCd: searchInfo?.custCd,
          userInfo,
        },
        {
          onSuccess: (rows) => {
            setRowData1(
              (rows || []).map((row, index) => ({
                ...row,
                no: index + 1,
                evaPoint: row.obtainedScore ?? row.evaPoint ?? 0,
              }))
            );
          },
        }
      );
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  }, [ResetLogic1, validateSelection, search1, searchInfo, userInfo, dispatch]);

  //#endregion
  //#region 양식 팝업
  const selectedCustNm =
    searchInfo?.custList?.find(
      (c) => String(c.value) === String(searchInfo?.custCd || '')
    )?.name || '';

  const SearchFormListLogic = useCallback(async () => {
    const custCd = searchInfo?.custCd || '';
    if (!custCd) return [];

    setFormListLoading(true);
    try {
      let rows = [];
      await searchFormList.runAsync(
        { custCd },
        {
          onSuccess: (data) => {
            rows = (data || []).map(MapFormListRow).filter((r) => r.formCode);
          },
        }
      );

      if (!rows.length) {
        rows = [];
      }

      setFormListRows(rows);
      return rows;
    } catch (e) {
      setFormListRows([]);
      return [];
    } finally {
      setFormListLoading(false);
    }
  }, [searchInfo?.custCd, searchFormList]);

  const OpenFormPopupLogic = useCallback(async () => {
    if (!validateSelection()) return;
    setFormPopupOpen(true);
    await SearchFormListLogic();
  }, [validateSelection, SearchFormListLogic]);

  const NavigateToDetailLogic = useCallback(
    (payload) => {
      navigate('/SeriousAccidentAct1', {
        state: {
          custCd: searchInfo?.custCd,
          custNm: selectedCustNm,
          ...payload,
        },
      });
    },
    [navigate, searchInfo?.custCd, selectedCustNm]
  );

  const HandleFormSelectLogic = useCallback(
    (row) => {
      if (!row?.versionId && !row?.formCode) return;
      setFormPopupOpen(false);
      NavigateToDetailLogic({
        screenMode: 'template',
        formCode: String(row.versionId ?? row.formCode),
        formVer: String(row.versionNo ?? row.formVer ?? ''),
        formName: row.versionNm ?? row.formName,
        versionId: row.versionId ?? row.formCode,
        status: row.status,
        readonlyYn: row.readonlyYn,
      });
    },
    [NavigateToDetailLogic]
  );

  const HandleFormAddNewLogic = useCallback(async () => {
    if (!validateSelection()) return;

    dispatch(showLoading());
    try {
      const result = await openDraftForm.runAsync({
        custCd: searchInfo?.custCd,
        userInfo,
      });
      const isSuccess = result?.isSuccess ?? result?.IsSuccess;
      if (!isSuccess) {
        throw new Error(result?.message || result?.Message || 'DRAFT 생성 실패');
      }

      const row = (Array.isArray(result?.data) ? result.data : [])?.[0];
      const formData = ParseFormDataResponse(row);
      setFormPopupOpen(false);
      NavigateToDetailLogic({
        screenMode: 'template',
        formCode: String(row?.versionId ?? ''),
        formVer: String(row?.versionNo ?? ''),
        formName: row?.versionNm ?? '',
        versionId: row?.versionId,
        status: row?.status ?? 'DRAFT',
        isNewForm: false,
        initialFormData: formData,
      });
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.message || '평가표 초안 생성 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  }, [
    validateSelection,
    dispatch,
    openDraftForm,
    searchInfo?.custCd,
    userInfo,
    NavigateToDetailLogic,
  ]);

  /** 신규 평가 추가 — ACTIVE(배포) 양식 있을 때만 이동 */
  const HandleEvaluateAddLogic = useCallback(async () => {
    if (!validateSelection()) return;

    dispatch(showLoading());
    try {
      let formRows = [];
      await searchFormList.runAsync(
        { custCd: searchInfo?.custCd },
        {
          onSuccess: (data) => {
            formRows = Array.isArray(data) ? data : [];
          },
        }
      );

      if (!HasActiveFormRow(formRows)) {
        dispatch(
          showSnackbar({
            message:
              '배포된 평가 양식(ACTIVE)이 없습니다. 평가표 관리에서 양식을 작성·배포한 후 평가를 진행해 주세요.',
            type: 'warning',
          })
        );
        return;
      }

      NavigateToDetailLogic({
        screenMode: 'evaluate',
        useActiveForm: true,
        data: {},
      });
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.message || '평가 양식 확인 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  }, [
    validateSelection,
    dispatch,
    searchFormList,
    searchInfo?.custCd,
    NavigateToDetailLogic,
  ]);

  const HandleTemplateManageLogic = useCallback(async () => {
    await OpenFormPopupLogic();
  }, [OpenFormPopupLogic]);
  //#endregion
  //#region 저장
  //저장버튼 클릭 시 함수(웹)
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    schema: SER_BASIC_Schema,
    getChangedRows: () => [], // 목록은 삭제만 지원
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: null,
    reset: () => {
      setChangedRowData1([]);
      setDeletedRowData1([]);
    },
    refresh: async () => {
      await SearchLogic1();
    },
  });

  const SaveLogic1 = async () => {
    const hasDelete = deletedRowData1.length > 0;
    if (!hasDelete) {
      dispatch(
        showSnackbar({ message: '삭제할 데이터가 없습니다.', type: 'warning' })
      );
      return;
    }
    await Save1();
  };

  //#endregion
  //#region 삭제

  //#endregion
  //#region 엑셀
  const LoadFormDetailForExcel = async (versionId) => {
    if (!versionId) return null;
    try {
      const params = mapParamsBySchema(SER_BASIC_FORM_Schema.mapper.search2, {
        custCd: searchInfo?.custCd,
        versionId: String(versionId),
        formCode: String(versionId),
      });
      const res = await apiRequest(
        'post',
        Global.urls.SeriousAccidentAct.getSerBasicR3,
        params
      );
      const rows = Array.isArray(res?.data) ? res.data : [];
      return ParseFormDataResponse(rows?.[0]);
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  const BuildExcelContextForRow = async (listRow) => {
    const sdCode = listRow?.sdCode;
    if (!sdCode) {
      throw new Error('평가 코드가 없습니다.');
    }

    const params1 = mapParamsBySchema(SER_BASIC_01_Schema.mapper.search1, {
      sdCode,
    });
    const res1 = await apiRequest(
      'post',
      Global.urls.SeriousAccidentAct.getSerBasic01R1,
      params1
    );
    const master = (Array.isArray(res1?.data) ? res1.data : [])?.[0];
    if (!master || master?.type === 'Error') {
      throw new Error(master?.message || '평가 마스터 조회에 실패했습니다.');
    }

    const params2 = mapParamsBySchema(SER_BASIC_01_Schema.mapper.search2, {
      sdCode,
    });
    const res2 = await apiRequest(
      'post',
      Global.urls.SeriousAccidentAct.getSerBasic01R2,
      params2
    );
    const detailRows = Array.isArray(res2?.data) ? res2.data : [];
    if (!detailRows.length || detailRows?.[0]?.type === 'Error') {
      throw new Error(
        detailRows?.[0]?.message || '평가 상세 조회에 실패했습니다.'
      );
    }

    const versionId =
      master.versionId ??
      master.formCode ??
      listRow.versionId ??
      listRow.formCode ??
      '';

    let evaluation = null;
    if (versionId) {
      const formData = await LoadFormDetailForExcel(versionId);
      if (formData) {
        evaluation = MergeTemplateWithDetailRows(formData, detailRows);
      }
    }
    if (!evaluation) {
      evaluation = MapDetailApiRowsToEvaluation(detailRows);
    }
    if (!evaluation?.arrayList?.length) {
      throw new Error('다운로드할 평가 항목이 없습니다.');
    }

    return {
      ...evaluation,
      dateValue: {
        evaDate: master.evaDate || listRow.evaDate,
        evaName: master.evaName || listRow.evaName,
      },
      totalPoint: master.evaPoint ?? evaluation.totalPoint,
      custNm: selectedCustNm,
    };
  };

  /** 선택 행 일괄 엑셀 다운로드 */
  const ExcelDownloadAllLogic = async () => {
    if (!validateSelection()) return;

    const targets = selectedRowData1 || [];
    if (!targets.length) {
      dispatch(
        showSnackbar({
          message: '다운로드할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      dispatch(showLoading());
      let successCount = 0;

      for (let i = 0; i < targets.length; i += 1) {
        const row = targets[i];
        if (!row?.sdCode) continue;

        const ctx = await BuildExcelContextForRow(row);
        const ok = await DownloadSeriousAccidentExcelAll(
          ctx,
          BuildSeriousAccidentExcelFileName({
            evaDate: ctx.dateValue?.evaDate,
            evaName: ctx.dateValue?.evaName,
            suffix: `${i + 1}_${dayjs().format('HHmmss')}`,
          })
        );
        if (ok) successCount += 1;
      }

      if (successCount === 0) {
        dispatch(
          showSnackbar({
            message: '다운로드할 평가 데이터가 없습니다.',
            type: 'warning',
          })
        );
      } else {
        dispatch(
          showSnackbar({
            message: `${successCount}건의 일괄 엑셀 다운로드가 완료되었습니다.`,
            type: 'success',
          })
        );
      }
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e?.message || '일괄 엑셀 다운로드 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion
  //#region 나머지 함수
  // 안전보건관리책임자 선임서 평가표 전체 인쇄 함수
  const PrintLogic1 = async (_item) => {
    let headerData = {};
    let tableData1 = [];

    try {
      if (!selectedRowData1 || selectedRowData1.length === 0) {
        dispatch(
          showSnackbar({
            message: '항목을 선택하세요.',
            type: 'warning',
          })
        );
        return;
      } else {
        const params1 = mapParamsBySchema(SER_BASIC_01_Schema.mapper.search1, {
          sdCode: _item.sdCode,
        });
        const res1 = await apiRequest(
          'post',
          Global.urls.SeriousAccidentAct.getSerBasic01R1,
          params1
        );
        const data = Array.isArray(res1?.data) ? res1.data : [];

        if (data.length === 0 || data?.[0]?.type === 'Error') {
          throw new Error(data?.[0]?.message || '인쇄할 데이터가 없습니다.');
        } else {
          const cust = custInfo.find((f) => f.custCd === searchInfo?.custCd);

          // 업종명(소분류)
          const industrialSmall = indList.find(
            (f) => f.indCd === cust.indCd
          )?.industrialSmall;

          // 평가등급 계산
          const workNo = cust?.workNo || 0; // WORK_NO 값
          const point = data[0]?.evaPoint || 0; // 총 점수
          let evaGrade = '초급'; // 기본값

          if (workNo >= 50 && workNo <= 300) {
            if (point < 400) {
              evaGrade = '초급'; //
            } else if (point >= 400 && point <= 559) {
              evaGrade = '중급';
            } else {
              evaGrade = '고급';
            }
          } else if (workNo >= 20 && workNo < 50) {
            if (point < 320) {
              evaGrade = '초급';
            } else if (point >= 320 && point <= 479) {
              evaGrade = '중급';
            } else {
              evaGrade = '고급';
            }
          } else if (workNo < 20) {
            if (point < 240) {
              evaGrade = '초급';
            } else if (point >= 240 && point <= 399) {
              evaGrade = '중급';
            } else {
              evaGrade = '고급';
            }
          }

          headerData = {
            ...data[0],
            evaDate: dayjs(_item.evaDate)
              .format('YYYY.MM.DD (dddd)')
              .replace('Monday', '월')
              .replace('Tuesday', '화')
              .replace('Wednesday', '수')
              .replace('Thursday', '목')
              .replace('Friday', '금')
              .replace('Saturday', '토')
              .replace('Sunday', '일'), // 평가일자
            ...cust,
            industrialSmall: industrialSmall, // 업종명
            workNo: workNo, // 상시근로자수
            evaGrade: evaGrade, // 평가등급
          };
        }

        const params2 = mapParamsBySchema(SER_BASIC_01_Schema.mapper.search2, {
          sdCode: _item.sdCode,
        });
        const res2 = await apiRequest(
          'post',
          Global.urls.SeriousAccidentAct.getSerBasic01R2,
          params2
        );
        const data2 = Array.isArray(res2?.data) ? res2.data : [];

        if (data2.length === 0 || data2?.[0]?.type === 'Error') {
          dispatch(
            showSnackbar({
              message: data2?.[0]?.message || '인쇄할 상세 데이터가 없습니다.',
              type: 'error',
            })
          );
          return;
        }

        // val1과 groupCd 기준으로 no 생성
        let currentVal1 = null;
        let currentGroupCd = null;
        let subNumber = 1;

        data2.forEach((item) => {
          item.title = Title[item.val1 - 1]; // 제목 매핑

          item.evaluation =
            item.checkYn === 'Y'
              ? '적정'
              : item.checkYn === 'N'
                ? '미흡'
                : item.checkYn === '0'
                  ? '해당없음'
                  : item.checkYn;

          if (item.checkYn === 'Y' || item.checkYn === '0') {
            const sameGroupCount = data2.filter(
              (d) => d.groupCd === item.groupCd
            ).length;
            item.score = item.val2 / sameGroupCount;
          } else {
            item.score = 0;
          }

          item.seriousDisasterNm =
            item.seriousDisaster.slice(-1) + '. ' + item.seriousDisasterNm;

          if (currentVal1 !== item.val1) {
            currentVal1 = item.val1;
            subNumber = 1;
          } else if (currentGroupCd !== item.groupCd) {
            subNumber++;
          }
          currentGroupCd = item.groupCd;
          item.no = `${item.val1}.${subNumber}`;
        });

        tableData1 = data2;
        const printData = {
          FileName: 'SER_BASIC',
          HeaderData: JSON.stringify(headerData),
          TableData1: JSON.stringify(tableData1),
        };
        await Commons.Axios(
          'report',
          Global.base.useUrl + Global.urls.Reports.reports,
          printData
        ).then((response) => {
          const blobUrl = URL.createObjectURL(response.data);
          window.open(blobUrl, '_blank'); // 새 탭에서 열기
        });
      }
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
    }
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  //#endregion

  return (
    <div className="wrap">
      <SER_BASIC
        userInfo={userInfo}
        //setUserInfo={setUserInfo}
        gridRef1={gridRef1}
        onGridReady={onGridReady}
        searchInfo={searchInfo}
        setSearchText={(t) => dispatch(setSearchText(t))}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        // 함수
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        SearchLogic1={SearchLogic1}
        SaveLogic1={SaveLogic1}
        PrintLogic1={PrintLogic1}
        handleRowSelection={handleRowSelection}
        deletedRowData1={deletedRowData1}
        setDeletedRowData1={setDeletedRowData1}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        NewYnErrorMsg={NewYnErrorMsg}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        HandleFormSelectLogic={HandleFormSelectLogic}
        HandleFormAddNewLogic={HandleFormAddNewLogic}
        HandleEvaluateAddLogic={HandleEvaluateAddLogic}
        HandleTemplateManageLogic={HandleTemplateManageLogic}
        NavigateToDetailLogic={NavigateToDetailLogic}
        ExcelDownloadAllLogic={ExcelDownloadAllLogic}
      />
      <SER_BASIC_FormPopup
        open={formPopupOpen}
        onClose={() => setFormPopupOpen(false)}
        rows={formListRows}
        loading={formListLoading}
        onSelect={HandleFormSelectLogic}
        onAddNew={HandleFormAddNewLogic}
      />
    </div>
  );
}

export default SER_BASICF;
